export const vendorsBaseUrl =
  'https://cdn.jsdelivr.net/npm/@live-codes/browser-compilers@0.6.5/dist/';

export const acornUrl = 'https://cdn.jsdelivr.net/npm/acorn@8.6.0/dist/acorn.min.js';

export const artTemplateUrl =
  'https://cdn.jsdelivr.net/npm/art-template@4.13.2/lib/template-web.js';

export const asciidocUrl =
  'https://cdn.jsdelivr.net/npm/@asciidoctor/core@2.2.5/dist/browser/asciidoctor.min.js';

export const assemblyscriptSdkUrl =
  'https://cdn.jsdelivr.net/npm/assemblyscript@0.19.22/dist/sdk.js';

export const assemblyscriptLoaderUrl =
  'https://cdn.jsdelivr.net/npm/@assemblyscript/loader@0.19.22/umd/index.js';

export const astringUrl = 'https://cdn.jsdelivr.net/npm/astring@1.7.5/dist/astring.min.js';

export const astroBaseUrl = 'https://cdn.jsdelivr.net/npm/@hatemhosny/astro-internal@0.0.4/';

export const astroWasmURL = 'https://cdn.jsdelivr.net/npm/@astrojs/compiler@0.9.2/astro.wasm';

export const autoCompleteUrl =
  'https://cdn.jsdelivr.net/npm/@tarekraafat/autocomplete.js@10.2.6/dist/autoComplete.min.js';

export const babelUrl = 'https://cdn.jsdelivr.net/npm/@babel/standalone@7.17.2/babel.min.js';

export const biwaschemeUrl =
  'https://cdn.jsdelivr.net/npm/biwascheme@0.7.4/release/biwascheme-min.js';

export const blocklyCdnBaseUrl = 'https://cdn.jsdelivr.net/npm/blockly@7.20211209.2/';

export const brythonBaseUrl = 'https://cdn.jsdelivr.net/npm/brython@3.10.4/';

export const chaiUrl = 'https://cdn.jsdelivr.net/npm/chai@4.3.6/+esm';

export const chaiTypesUrl = 'https://cdn.jsdelivr.net/npm/@types/chai@4.2.22/index.d.ts';

export const cjs2esUrl = 'https://cdn.jsdelivr.net/npm/cjs2es@1.1.1/dist/cjs2es.browser.min.js';

export const clioBaseUrl =
  'https://cdn.jsdelivr.net/npm/@live-codes/clio-browser-compiler@0.0.3/public/build/';

export const coffeeScriptUrl =
  'https://cdn.jsdelivr.net/npm/coffeescript@2.6.1/lib/coffeescript-browser-compiler-legacy/coffeescript.js';

export const cppWasmBaseUrl = 'https://cdn.jsdelivr.net/npm/@chriskoch/cpp-wasm@1.0.2';

export const csstreeUrl = 'https://cdn.jsdelivr.net/npm/css-tree@1.1.3/dist/csstree.min.js';

export const cytoscapeSvgUrl =
  'https://cdn.jsdelivr.net/npm/cytoscape-svg@0.4.0/cytoscape-svg.min.js';

export const cytoscapeUrl = 'https://cdn.jsdelivr.net/npm/cytoscape@3.22.0/dist/cytoscape.min.js';

export const dotUrl = 'https://cdn.jsdelivr.net/npm/dot@1.1.3/doT.min.js';

export const ejsUrl = 'https://cdn.jsdelivr.net/npm/ejs@3.1.6/ejs.min.js';

export const elkjsBaseUrl = 'https://cdn.jsdelivr.net/npm/elkjs@0.7.1/lib/';

export const emmetMonacoUrl =
  'https://cdn.jsdelivr.net/npm/emmet-monaco-es@5.0.0/dist/emmet-monaco.min.js';

export const esModuleShimsUrl =
  'https://cdn.jsdelivr.net/npm/es-module-shims@1.4.4/dist/es-module-shims.min.js';

export const etaUrl = 'https://cdn.jsdelivr.net/npm/eta@2.0.1/dist/eta.umd.min.js';

export const flexSearchUrl =
  'https://cdn.jsdelivr.net/npm/flexsearch@0.7.21/dist/flexsearch.bundle.min.js';

export const fontAnonymousProUrl =
  'https://cdn.jsdelivr.net/npm/@fontsource/anonymous-pro@4.5.9/index.min.css';

export const fontCascadiaCodeUrl =
  'https://cdn.jsdelivr.net/npm/@fontsource/cascadia-code@4.2.1/index.min.css';

export const fontCodeNewRomanUrl = 'https://fonts.cdnfonts.com/css/code-new-roman-2';

export const fontComicMonoUrl = 'https://cdn.jsdelivr.net/npm/comic-mono@0.0.1/index.min.css';

export const fontCourierPrimeUrl =
  'https://cdn.jsdelivr.net/npm/@fontsource/courier-prime@4.5.9/index.min.css';

export const fontDECTerminalModernUrl = 'https://fonts.cdnfonts.com/css/dec-terminal-modern';

export const fontDejaVuMonoUrl =
  'https://cdn.jsdelivr.net/npm/@fontsource/dejavu-mono@4.5.4/index.min.css';

export const fontFantasqueUrl =
  'https://cdn.jsdelivr.net/npm/@typopro/web-fantasque-sans-mono@3.7.5/TypoPRO-FantasqueSansMono.css';

export const fontFiraCodeUrl = 'https://cdn.jsdelivr.net/npm/firacode@6.2.0/distr/fira_code.css';

export const fontFixedsysUrl = 'https://fonts.cdnfonts.com/css/fixedsys-62';

export const fontHackUrl = 'https://cdn.jsdelivr.net/npm/hack-font@3.3.0/build/web/hack.css';

export const fontHermitUrl = 'https://cdn.jsdelivr.net/npm/typeface-hermit@0.0.44/index.min.css';

export const fontIBMPlexMonoUrl =
  'https://fonts.googleapis.com/css2?family=IBM+Plex+Mono&display=swap';

export const fontInconsolataUrl =
  'https://fonts.googleapis.com/css2?family=Inconsolata&display=swap';

export const fontIosevkaUrl =
  'https://cdn.jsdelivr.net/npm/@fontsource/iosevka@4.5.4/index.min.css';

export const fontJetbrainsMonoUrl =
  'https://cdn.jsdelivr.net/npm/@fontsource/jetbrains-mono@4.5.11/index.min.css';

export const fontMenloUrl = 'https://fonts.cdnfonts.com/css/menlo';

export const fontMonofurUrl = 'https://fonts.cdnfonts.com/css/monofur';

export const fontMonoidUrl =
  'https://cdn.jsdelivr.net/npm/@typopro/web-monoid@3.7.5/TypoPRO-Monoid.css';

export const fontNotoUrl = 'https://fonts.googleapis.com/css2?family=Noto+Sans+Mono&display=swap';

export const fontNovaMonoUrl = 'https://fonts.googleapis.com/css2?family=Nova+Mono&display=swap';

export const fontOpenDyslexicUrl =
  'https://cdn.jsdelivr.net/npm/@fontsource/opendyslexic@4.5.4/index.min.css';

export const fontProFontWindowsUrl = 'https://fonts.cdnfonts.com/css/profontwindows';

export const fontRobotoMonoUrl =
  'https://cdn.jsdelivr.net/npm/@fontsource/roboto-mono@4.5.8/index.min.css';

export const fontSFMonoUrl = 'https://fonts.cdnfonts.com/css/sf-mono';

export const fontSourceCodeProUrl =
  'https://cdn.jsdelivr.net/npm/@fontsource/source-code-pro@4.5.12/index.min.css';

export const fontSpaceMonoUrl =
  'https://cdn.jsdelivr.net/npm/@fontsource/space-mono@4.5.10/index.min.css';

export const fontSudoVarUrl = 'https://fonts.cdnfonts.com/css/sudo-var';

export const fontUbuntuMonoUrl =
  'https://cdn.jsdelivr.net/npm/@fontsource/ubuntu-mono@4.5.11/index.min.css';

export const fontVictorMonoUrl = 'https://cdn.jsdelivr.net/npm/victormono@1.5.4/dist/index.min.css';

export const fscreenUrl = 'https://cdn.jsdelivr.net/npm/fscreen@1.2.0/dist/fscreen.esm.js';

export const githubMarkdownCss =
  'https://cdn.jsdelivr.net/npm/github-markdown-css@5.1.0/github-markdown.min.css';

export const go2jsBaseUrl = 'https://cdn.jsdelivr.net/npm/@live-codes/go2js@0.3.0/build';

export const graphreCdnUrl = 'https://cdn.jsdelivr.net/npm/graphre@0.1.3/dist/graphre.js';

export const handlebarsBaseUrl = 'https://cdn.jsdelivr.net/npm/handlebars@4.7.7/dist/';

export const highlightjsUrl =
  'https://cdn.skypack.dev/pin/highlight.js@v11.5.1-ByzFRPBe5lvvwKChRHdq/mode=imports,min/optimized/highlightjs.js';

export const hintCssUrl = 'https://cdn.jsdelivr.net/npm/hint.css@2.7.0/hint.min.css';

export const hpccJsCdnUrl = 'https://cdn.jsdelivr.net/npm/@hpcc-js/wasm@1.12.9/dist/index.min.js';

export const imbaBaseUrl = 'https://cdn.jsdelivr.net/npm/imba@2.0.0-alpha.201/dist/';

export const jestLiteUrl = 'https://cdn.jsdelivr.net/npm/jest-lite@1.0.0-alpha.4/dist/core.js';

export const jestTypesUrl = 'https://cdn.jsdelivr.net/npm/@types/jest@27.4.1/index.d.ts';

export const jsclUrl = 'https://cdn.jsdelivr.net/npm/jscl@0.8.2/jscl.min.js';

export const jsZipUrl = 'https://cdn.jsdelivr.net/npm/jszip@3.10.1/dist/jszip.min.js';

export const juliaWasmBaseUrl = 'https://cdn.jsdelivr.net/npm/@chriskoch/julia-wasm@1.0.4';

export const liquidJsUrl =
  'https://cdn.jsdelivr.net/npm/liquidjs@9.34.0/dist/liquid.browser.min.js';

export const localforageUrl =
  'https://cdn.jsdelivr.net/npm/localforage@1.10.0/dist/localforage.min.js';

export const luaUrl = 'https://cdn.jsdelivr.net/npm/fengari-web@0.1.4/dist/fengari-web.min.js';

export const lunaObjViewerStylesUrl =
  'https://cdn.jsdelivr.net/npm/luna-object-viewer@0.2.0/luna-object-viewer.css';

export const lunaConsoleStylesUrl =
  'https://cdn.jsdelivr.net/npm/luna-console@0.2.1/luna-console.css';

export const malinaUrl = 'https://cdn.jsdelivr.net/npm/malinajs@0.6.52/malina.js';

export const markedUrl = 'https://cdn.jsdelivr.net/npm/marked@4.0.12/marked.min.js';

export const mermaidCdnUrl = 'https://cdn.jsdelivr.net/npm/mermaid@9.1.3/dist/mermaid.min.js';

export const mjmlUrl = 'https://cdn.jsdelivr.net/npm/mjml-browser@4.14.1/lib/index.min.js';

export const monacoEmacsUrl = 'https://unpkg.com/monaco-emacs@0.3.0/dist/monaco-emacs.js';

export const monacoVimUrl = 'https://unpkg.com/monaco-vim@0.3.5/dist/monaco-vim.js';

export const mustacheUrl = 'https://cdn.jsdelivr.net/npm/mustache@4.2.0/mustache.min.js';

export const nomnomlCdnUrl = 'https://cdn.jsdelivr.net/npm/nomnoml@1.4.0/dist/nomnoml.min.js';

export const normalizeCssUrl = 'https://cdn.jsdelivr.net/npm/normalize.css@8.0.1/normalize.min.css';

export const nunjucksBaseUrl = 'https://cdn.jsdelivr.net/npm/nunjucks@3.2.3/browser/';

export const opalBaseUrl = 'https://cdn.opalrb.com/opal/1.4.1/';

export const parinferUrl =
  'https://cdn.jsdelivr.net/npm/@chrisoakman/parinfer@3.13.1/parinfer.min.js';

export const pintoraUrl =
  'https://cdn.jsdelivr.net/npm/@pintora/standalone@0.1.0/lib/pintora-standalone.umd.min.js';

export const plotlyCdnUrl = 'https://cdn.jsdelivr.net/npm/plotly.js@2.9.0/dist/plotly.min.js';

export const postcssImportUrlUrl =
  'https://cdn.jsdelivr.net/npm/@live-codes/postcss-import-url@0.1.2/dist/postcss-import-url.js';

export const prettierBaseUrl = 'https://cdn.jsdelivr.net/npm/prettier@2.5.1/';

export const prettierPhpUrl =
  'https://cdn.jsdelivr.net/npm/@prettier/plugin-php@0.18.0/standalone.js';

export const prismBaseUrl = 'https://cdn.jsdelivr.net/npm/prismjs@1.26.0/components/';

export const pyodideBaseUrl = 'https://cdn.jsdelivr.net/pyodide/v0.18.1/full/';

export const qrcodeUrl = 'https://cdn.jsdelivr.net/npm/qrcode-generator@1.4.4/qrcode.min.js';

export const quillEditorCdnBaseUrl = 'https://cdn.jsdelivr.net/npm/quill@2.0.0-dev.4/dist';

export const quillHtmlEditUrl =
  'https://cdn.jsdelivr.net/npm/quill-html-edit-button@2.2.7/dist/quill.htmlEditButton.min.js';

export const quillBlotFormaterUrl =
  'https://cdn.jsdelivr.net/npm/quill-blot-formatter@1.0.5/dist/quill-blot-formatter.min.js';

export const quillBetterTableBaseUrl =
  'https://cdn.jsdelivr.net/npm/quill-better-table@1.2.10/dist';

export const requireUrl = 'https://cdnjs.cloudflare.com/ajax/libs/require.js/2.3.6/require.min.js';

export const rescriptCompilerUrl = 'https://cdn.rescript-lang.org/v9.1.2/compiler.js';

export const rescriptReactUrl = 'https://cdn.rescript-lang.org/v9.1.2/%40rescript/react/cmij.js';

export const rescriptStdLibBaseUrl = 'https://cdn.jsdelivr.net/npm/@rescript/std@9.1.3/lib/es6/';

export const resetCssUrl = 'https://cdn.jsdelivr.net/npm/reset-css@5.0.1/reset.min.css';

export const riotBaseUrl = 'https://cdn.jsdelivr.net/npm/riot@6.1.2/';

export const snackbarUrl =
  'https://cdn.jsdelivr.net/npm/@snackbar/core@1.7.0/dist/snackbar.min.css';

export const spacingJsUrl = 'https://cdn.jsdelivr.net/npm/spacingjs@1.0.7/dist/bundle.min.js';

export const sqlFormatterUrl =
  'https://cdn.jsdelivr.net/npm/sql-formatter@4.0.2/dist/sql-formatter.min.js';

export const sqljsBaseUrl = 'https://cdn.jsdelivr.net/npm/sql.js@1.6.2/dist/';

export const stencilUrl =
  'https://cdn.jsdelivr.net/npm/@stencil/core@2.13.0/compiler/stencil.min.js';

export const stylisUrl = 'https://cdn.jsdelivr.net/npm/stylis@4.1.3/dist/umd/stylis.min.js';

export const svgbobWasmCdnUrl =
  'https://cdn.jsdelivr.net/npm/svgbob-wasm@0.4.1-a0/svgbob_wasm_bg.wasm';

export const tagifyBaseUrl = 'https://cdn.jsdelivr.net/npm/@yaireo/tagify@4.9.6/dist/';

export const tailwindcssUrl =
  'https://cdn.jsdelivr.net/npm/@live-codes/tailwindcss-browser-plugin@0.3.2/dist/tailwindcss.umd.min.js';

export const tauPrologBaseUrl = 'https://cdn.jsdelivr.net/npm/tau-prolog@0.3.2/modules/';

export const twigUrl = 'https://cdn.jsdelivr.net/npm/twig@1.15.4/twig.min.js';

export const typescriptUrl = 'https://cdn.jsdelivr.net/npm/typescript@4.5.5/lib/typescript.min.js';

export const uniterUrl = 'https://cdn.jsdelivr.net/npm/uniter@2.17.0/dist/uniter.js';

export const vegaCdnUrl = 'https://cdn.jsdelivr.net/npm/vega@5.21.0/build/vega.min.js';

export const vegaLiteCdnUrl = 'https://cdn.jsdelivr.net/npm/vega-lite@5.2.0/build/vega-lite.min.js';

export const vueSfcLoaderCdnBaseUrl = 'https://cdn.jsdelivr.net/npm/vue3-sfc-loader@0.8.4/dist/';

export const wabtjsUrl = 'https://cdn.jsdelivr.net/npm/wabt@1.0.26/index.js';

export const waveDromBaseUrl = 'https://cdn.jsdelivr.net/npm/wavedrom@2.9.0/';

export const webRBaseUrl = 'https://cdn.jsdelivr.net/npm/@r-wasm/webr@0.1.1/dist/';
